<div class="p-6">
  <h2 class="text-gray-700 font-bold mb-4">
    Recusar {{ data.count > 1 ? data.count + ' OS selecionadas' : 'OS' }}
  </h2>

  <p class="text-sm text-gray-500 mb-3">
    O motivo é obrigatório e vai ser mostrado ao fornecedor {{ data.count > 1 ? 'em todas as OS selecionadas' : '' }} pra que ele saiba o que corrigir.
  </p>

  <form [formGroup]="form">
    <mat-form-field class="input-tg w-full" appearance="outline">
      <mat-label>Motivo da recusa *</mat-label>
      <textarea matInput formControlName="motivo" rows="3"></textarea>
    </mat-form-field>
  </form>

  <div class="flex justify-end gap-2 mt-2">
    <button mat-flat-button class="btn-tg-white" (click)="cancel()">Cancelar</button>
    <button mat-flat-button class="btn-tg" [disabled]="form.invalid" (click)="confirm()">Recusar</button>
  </div>
</div>
